import { Component, Input, OnInit, computed, effect, inject, signal } from '@angular/core';
import { AddCustomerBankAccountComponent } from 'src/app/BankAccount/add-customer-bank-account/add-customer-bank-account.component';
import { BasicDialogComponent } from 'src/app/BaseDialog/basic-dialog/basic-dialog.component';
import { CUSTOMER_DOCUSEAL_TYPE } from 'src/app/constants';
import { DialogItem } from 'src/app/dialog-item';
import { DocusealHistoryComponent } from 'src/app/Others/docuseal-history/docuseal-history.component';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Contact } from 'src/model/contact.model';
import { Customer } from 'src/model/customer.model';
import { CustomerAccount } from 'src/model/customerAccount.model';
import { ContactService } from 'src/services/contact.service';
import { CustomerAccountService } from 'src/services/customer-account.service';
import { DocusealService } from 'src/services/docuseal.service';

@Component({
	selector: 'app-customer-account-list',
	templateUrl: './customer-account-list.component.html',
	styleUrl: './customer-account-list.component.scss',
	standalone: false
})
export class CustomerAccountListComponent implements OnInit {
	private sharedService = inject(SharedService);
	private customerAcctService = inject(CustomerAccountService);
	private contactService = inject(ContactService);
	private docusealService = inject(DocusealService);

	@Input() viewCustomer: Customer;
	allAccounts = signal<CustomerAccount[]>([]);
	accountList = computed(() => {
		const r = this.sharedService.groupByNumKey(this.allAccounts(), 'ContactId');
		const { '-1': customer = [], ...contact } = r;
		return { customer, contact };
	});
	contacts = computed(() => Object.keys(this.accountList().contact).map(k => Number(k)));

	contactList: Contact[] = [];

	constructor() {
		effect(() => {
			const c = this.contacts();
			if (c.length > 0 && this.contactList.length === 0) this.getContacts();
		});
	}

	ngOnInit(): void {
		this.getData();
	}

	async getData() {
		const a = await this.customerAcctService.getAllCustomerAccounts([this.viewCustomer.ID]);
		this.allAccounts.set(a);
	}

	async getContacts() {
		this.contactList = await this.contactService.getAllCustomerContacts(this.viewCustomer.ID);
	}

	getAccountContactDetails(contactId: number) {
		return this.contactList.find(contact => contact.ID == contactId);
	}

	openAddBankAccountModal(account?: CustomerAccount) {
		let o =
			account === undefined ?
				{ customer: this.viewCustomer }
			:	{ account: account, isContactAcct: account.ContactId !== undefined, customer: this.viewCustomer, selectedContactId: account.ContactId };
		const modalRef = this.sharedService.openModal(BasicDialogComponent);
		const i = modalRef.componentInstance as BasicDialogComponent;
		i.title = 'Add Customer Bank Account';
		i.injectContent = [new DialogItem(AddCustomerBankAccountComponent, o)];
		modalRef.result.then(addedAcct => {
			if (addedAcct != undefined) {
				this.allAccounts.update(accounts => {
					return [...accounts, addedAcct];
				});
			}
		});
	}

	async openViewDocusealHistory() {
		var dsList = await this.docusealService.getCustomerDocuseals(this.viewCustomer.ID, CUSTOMER_DOCUSEAL_TYPE.ACCOUNT_AUTHORIZATION);
		const modalRef = this.sharedService.openModal(DocusealHistoryComponent);
		modalRef.componentInstance.dsList = dsList;
	}
}
